import api from '../../api/apiSlice';

type SeedRendersRequest = { userId: number; url: string; time: string; count: number };
type SeedRendersResponse = { seeded: number; renderCounter: number };

export const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addAchPayment: builder.mutation<void, number>({
      query: (userId) => ({
        url: `/users/${userId}/add-ach-payment`,
        method: 'Post',
      }),
    }),
    seedRenders: builder.mutation<SeedRendersResponse, SeedRendersRequest>({
      query: ({ userId, ...body }) => ({
        url: `/users/${userId}/seed-renders`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useAddAchPaymentMutation, useSeedRendersMutation } = usersApi;
